import React from 'react';
import AgentSupportComponent from '../../../Components/Support/AgentSupport';

export default function AgentSupport() {
    return (
        <div className='page-body'>
            <AgentSupportComponent />
        </div>
    );
}